import {
    Component,
    ElementRef,
    ViewEncapsulation,
    input,
    inject,
    computed,
    ChangeDetectionStrategy,
    booleanAttribute,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --height: initial; --width: auto; display: block; height: var(--height, 24px); width: var(--width); } :host img { max-height: 100%; height: auto; max-width: 100%; width: auto; }`,
);

@Component({
    selector: 'bazis-logo',
    template: `
        <img
            part="image"
            alt="Project Logo"
            [attr.src]="src()"
        />
    `,
    // styleUrls: ['logo.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LogoElement implements OnInit {
    public el = inject(ElementRef);

    // Отображение только значка
    readonly short = input(false, { transform: booleanAttribute });

    // Отображение значка и укороченного тайтла
    readonly medium = input(false, { transform: booleanAttribute });

    readonly type = input<'light' | 'dark'>('dark');

    readonly grayscale = input(false, { transform: booleanAttribute });

    readonly src = computed(() => {
        let src = '/assets/logos/on-' + this.type();

        if (this.short()) {
            src += '-short';
        }

        if (this.medium()) {
            src += '-medium';
        }

        if (this.grayscale()) {
            src += '-grayscale';
        }

        return src + '.svg';
    });

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
